import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';

/**
 * Deletes a passkey for the current user.
 *
 * @param params.passkeyId - The unique identifier of the passkey to delete.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the passkey is successfully deleted.
 */
export const deletePasskey = async (
  { passkeyId }: { passkeyId: string },
  client = getDefaultClient()
): Promise<void> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  await apiClient.deletePasskey({
    deleteUserPasskeyRequest: {
      passkeyId,
    },
    environmentId: core.environmentId,
  });
};
